import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable()
export class DefaultImageService {

  // null or empty 면 닫힘
  readonly src = new EventEmitter<string | null>();
}
